import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableFilterCellComponent } from '../table-filter-cell/table-filter-cell.component';
import { FilterConfigByKeyPipe } from '../../pipes/filter-config-by-key.pipe';
import { ColumnTypeCssClassPipe } from '../../pipes/column-type-css-class.pipe';
import { ColumnKeyCssClassPipe } from '../../pipes/column-key-css-class.pipe';
import { TableColumn } from '../../models/table-column';
import { TableFilterConfig } from '../../models/table-filter-config';
import { TableFilterChangeEvent } from '../../events/table-filter-change.event';
import { ColumnKey } from '../../types/column-key';
import { TableModule } from 'primeng/table';
import { valueOrDefault } from '@web/utils';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[app-table-filter-row]',
  imports: [
    CommonModule,
    TableFilterCellComponent,
    FilterConfigByKeyPipe,
    ColumnTypeCssClassPipe,
    ColumnKeyCssClassPipe,
    TableFilterCellComponent,
    ColumnTypeCssClassPipe,
    ColumnKeyCssClassPipe,
    FilterConfigByKeyPipe,
    TableModule,
  ],
  templateUrl: './table-filter-row.component.html',
  styleUrls: ['./table-filter-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableFilterRowComponent<Item, Filter> {
  public readonly columns = input.required<TableColumn<Item, Filter>[]>();
  public readonly filters = input.required<TableFilterConfig<Filter>[]>();
  public readonly reordering = input.required<boolean>();
  public readonly changes = output<TableFilterChangeEvent<Filter>>();
  protected readonly valueOrDefault = valueOrDefault;

  public columnKey = (
    index: number,
    column: TableColumn<Item, Filter>,
  ): ColumnKey<Item> => column.key;

  public handleFilterChanges(event: TableFilterChangeEvent<Filter>): void {
    this.changes.emit(event);
  }
}
